<template>
  <VTooltip v-if="breakdown?.total" theme="info-tooltip" class="block min-w-32">
    <div class="flex h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
      <div
        v-for="band in filledBands"
        :key="band.key"
        :class="band.colorClass"
        :style="{ width: `${(band.count / breakdown.total) * 100}%` }"
      />
    </div>
    <div class="mt-1 truncate text-xs text-gray-500">
      {{ t("top_band") }}
      <span class="font-semibold text-gray-700">{{ topBand.label }}</span>
      <span class="tabular-nums">· {{ topBand.share }} %</span>
    </div>
    <template #popper>
      <table class="text-xs tabular-nums">
        <tr v-for="band in bands" :key="band.key" :class="band.count ? '' : 'text-gray-400'">
          <td class="pr-2"><span class="inline-block size-2 rounded-full" :class="band.colorClass" /></td>
          <td class="pr-3">{{ band.label }}</td>
          <td class="pr-2 text-right font-semibold">{{ band.count }}</td>
          <td class="text-right">{{ band.share }} %</td>
        </tr>
      </table>
    </template>
  </VTooltip>
  <span v-else class="block text-right text-gray-400">—</span>
</template>

<script>
import { useI18n } from "vue-i18n";
import { formatPrice } from "@estaly/ui";
import { bandClass, sharePercent } from "./grossSalesBreakdown";

export default {
  props: {
    breakdown: { type: Object, default: null },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    bands() {
      const priceBands = this.breakdown?.priceBands || [];
      const knownBandsCount = priceBands.filter((band) => band.min != null).length;

      return priceBands.map((band, index) => ({
        key: `${band.min}-${band.max}`,
        label:
          band.min == null
            ? this.t("unknown_band")
            : this.t("band", { min: formatPrice(band.min), max: formatPrice(band.max) }),
        count: band.count,
        share: sharePercent(band.count, this.breakdown.total),
        colorClass: bandClass(band, index, knownBandsCount),
      }));
    },

    filledBands() {
      return this.bands.filter((band) => band.count > 0);
    },

    // First band wins a tie, i.e. the cheapest one.
    topBand() {
      return this.filledBands.reduce((top, band) => (band.count > top.count ? band : top));
    },
  },
};
</script>

<i18n src="./GrossSalesPriceBands.i18n.json"></i18n>
